<template>
  <div class="checkbox-option">
    <div :class="['questionnaire-container checkbox-container row visible-on col-sm-5 col-md-8 col-lg-5 col-sm-offset-3 col-md-offset-1 col-lg-offset-4', align === 'left' ? 'align-left' : 'align-center']">
        <div class="checkbox" @click="select"><img v-if="internalValue === '1'" :src="checkboxSelect" alt=""></div>
        <div class="agreement-content">
          <div class="agreement-title" :class="displayLinkUrl && !modal ? 'link-text' : ''" @click="selectOrLink">{{ text }}</div>
          <div v-show="hasLinkDescription" class="agreement-text plain-text">{{ displayLinkText }}</div>
        </div>
        <questionnaire-modal v-if="modal" v-show="showPolicy" v-model="showPolicy" :title="modal['title']" :body="modal['body']"></questionnaire-modal>
    </div>
    <div v-if="internalErrorMessage" class="col-xs-12 col-sm-5 col-md-8 col-lg-5 col-sm-offset-3 col-md-offset-1 col-lg-offset-4 error-text error-message">{{ this.internalErrorMessage }}</div>
  </div>
</template>
<script>
import QuestionnaireModal from '@/components/questionnaire/form/Modal'
import { questionnaireMixin } from './mixin.js'
// @text: the text content.
// @value: whether this field is selected.
// @link: open the link when clicking it.
// @isRequired: whether this field can be empty.
// @modal: open the modal when clicking it.(follow the Modal component) e.g.: {title: '', body: ''}

export default {
  props: {
    text: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    link: {
      type: String,
      default: ''
    },
    linkText: {
      type: String,
      default: ''
    },
    linkUrl: {
      type: String,
      default: ''
    },
    isRequired: {
      type: Boolean,
      default: false
    },
    modal: {
      type: Object,
      default: null
    },
    align: {
      type: String,
      default: ''
    },
    hasLinkDescription: {
      type: Boolean,
      default: false
    }
  },
  mixins: [questionnaireMixin],
  components: {
    QuestionnaireModal
  },
  data () {
    return {
      checkboxSelect: require('@/assets/image/questionnaire/common/checkbox-selected.png'),
      internalValue: '',
      showPolicy: false,
      internalErrorMessage: ''
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  created () {
    this.internalValue = this.value
  },
  watch: {
    value: {
      handler (val, oldVal) {
        this.internalValue = val
      },
      immediate: true
    },
    internalValue (val) {
      this.$emit('change', val)
    },
    '$i18n.locale' (val) {
      this.validate()
    }
  },
  computed: {
    displayLinkText () {
      return this.linkText || this.link || ''
    },
    displayLinkUrl () {
      const rawLink = this.linkUrl || this.link || ''
      if (!rawLink) {
        return ''
      }
      const link = `${rawLink}`
      if (!link.startsWith('http')) {
        return `http://${link}`
      }
      return link
    }
  },
  methods: {
    validate () {
      if (this.fieldIsRequired(this.isRequired) && this.internalValue !== '1') {
        this.internalErrorMessage = this.isRequiredMessage
        return false
      }
      return true
    },
    select () {
      this.internalValue = this.internalValue === '1' ? '0' : '1'
      if (this.internalValue === '1') {
        this.internalErrorMessage = ''
      }
    },
    selectOrLink () {
      if (this.displayLinkUrl && !this.modal) {
        let link = this.displayLinkUrl
        if (!link.startsWith('http')) {
          link = `http://${link}`
        }
        window.open(link)
        return
      }
      if (this.modal) {
        this.showPolicy = true
        return
      }
      this.select()
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/onboarding-common.scss';
@import '@/assets/scss/questionnaire-common.scss';
.align-left {
    justify-content: flex-start;
}
.align-center {
    justify-content: center;
}
.checkbox-option {
  $checkbox-size: 15px;
  $title-line-height: 24px;

  .checkbox-container {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    font-size: 14px;
    line-height: 22px;

    .agreement-content {
      flex: 1;
      min-width: 0;
      margin-left: 12px;
      .agreement-title {
        margin: 0;
        color: #303133;
        cursor: pointer;
        font-size: 15px;
        font-weight: 600;
        line-height: $title-line-height;
        user-select: none;
        overflow-wrap: break-word;
      }

      .agreement-text {
        display: block;
        margin-top: 8px;
        user-select: none;
        overflow-wrap: break-word;
        white-space: pre-line;
        font-size: 14px;
      }

      .link-text {
        color: #0096cc;
        cursor: pointer;
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }
    }

    .plain-text {
      color: #606266;
      cursor: default;
    }

    .checkbox {
      border: solid 1px black;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      width: $checkbox-size;
      height: $checkbox-size;
      margin-top: ($title-line-height - $checkbox-size) / 2;
      flex-shrink: 0;
      cursor: pointer;
      img {
        user-select: none;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }

  .error-message {
    padding-left: 10px;
  }
}
</style>
